import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiBlockDocumentComponent } from './eui-block-document.component';

@NgModule({
    imports: [CommonModule],
    exports: [EuiBlockDocumentComponent],
    declarations: [EuiBlockDocumentComponent]
})
export class EuiBlockDocumentComponentModule {
}
